<template>
  <div class="compressed-content">
    <h3 class="page-question">When you smoked, how many packs a day did you smoke? How many years did you smoke? How long ago did you stop smoking?</h3>
    <div class="page-buttons">
      <v-form-group :validator="$v.packsPerDayInPast" label="Packs per day">
        <form-select slot-scope="{ attrs, listeners }"
                     v-bind="attrs"
                     v-on="listeners"
                     :options="smokingPacks" 
                     v-model="survey.smoking.packsPerDayInPast"
                     @input="survey.smoking.packsPerDayInPast = $event.value"
                     placeholder="Packs per day" />
      </v-form-group>
      <v-form-group :validator="$v.yearsSmokedInPast" label="Years smoking">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.smoking.yearsSmokedInPast"
                      placeholder="Years smoking" />
      </v-form-group>
      <v-form-group :validator="$v.yearStoppedSmoking" label="Year you stopped smoking">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.smoking.yearStoppedSmoking"
                      placeholder="Years smoking" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric, decimal } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';

  import { smokingPacks } from '@/constants';

  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    data() {
      return {
        smokingPacks,
      }
    },

    validations: {
      packsPerDayInPast: {
        required,
        between: between(0.5, 5),
        decimal
      },
      yearsSmokedInPast: {
        required,
        between: between(1, 80),
        numeric
      },
      yearStoppedSmoking: {
        required,
        between: between(new Date().getFullYear() - 90, new Date().getFullYear()),
        numeric
      }
    },

    computed: {
      ...mapState(["survey"]),

      packsPerDayInPast() { return this.survey.smoking.packsPerDayInPast; },
      yearsSmokedInPast() { return this.survey.smoking.yearsSmokedInPast; },
      yearStoppedSmoking() { return this.survey.smoking.yearStoppedSmoking; }
    }
  };
</script>
